import { Box } from '@mui/material';
import { ReactNode } from 'react';

import { PageNavbar } from 'features/PageNavbar';
import { PageNavItem } from 'features/PageNavbar/model/types/PageNavBarTypes';
import { innerNavFixPosition, innerNavHeight } from 'shared/const/styles';

interface PageProps {
    children: ReactNode;
    navList?: PageNavItem[];
    navTitle?: string | null;
    bgColor?: string;
    padding?: string;
    dataTestId?: string;
    /**
     * Fill the panel height so nested regions can scroll (CatalogPage pattern).
     * Use for flows with a sticky page footer (e.g. add items to order).
     */
    fillHeight?: boolean;
}

export const Page = ({
    children,
    navList,
    navTitle,
    bgColor,
    padding,
    dataTestId,
    fillHeight = false,
}: PageProps) => {
    return (
        <Box
            padding="24px"
            display="flex"
            gap={navList ? '12px' : '8px'}
            data-testid={dataTestId ?? 'Page'}
        >
            <Box
                position="sticky"
                top={innerNavFixPosition}
                bgcolor="background.paper"
                borderRadius="12px"
                overflow="hidden"
                height={innerNavHeight}
            >
                {navList && <PageNavbar navList={navList} title={navTitle} />}
            </Box>
            <Box
                flex="1"
                bgcolor={bgColor || 'background.paper'}
                borderRadius="12px"
                overflow="hidden"
                height={innerNavHeight}
                sx={{
                    overflowY: fillHeight ? 'hidden' : 'scroll',
                    position: 'relative',
                    overscrollBehavior: 'contain',
                }}
                id="right_side_page"
                display="flex"
                flexDirection="column"
            >
                <Box
                    className="page-content"
                    sx={{
                        padding: padding || '24px 16px',
                        boxSizing: 'border-box',
                        ...(fillHeight
                            ? {
                                  display: 'flex',
                                  flexDirection: 'column',
                                  flex: 1,
                                  minHeight: 0,
                                  overflow: 'hidden',
                              }
                            : undefined),
                        '&.sticky-visible': {
                            paddingBottom: '0px',
                        },
                    }}
                >
                    {children}
                </Box>
            </Box>
        </Box>
    );
};
